import { LegacyEditSetupAppModalFormStore } from "@/apps/list/modal/SetupAppModal"
import { ContentModuleUtils } from "@/content-usage/ContentModuleUtils"
import {
  DiscoAlert,
  DiscoFormControl,
  DiscoSwitch,
  DiscoText,
  DiscoTooltip,
} from "@disco-ui"
import { observer } from "mobx-react-lite"

interface CurriculumTimeEstimateSettingProps {
  form: LegacyEditSetupAppModalFormStore
}

function ContentCurriculumTimeEstimateSetting({
  form,
}: CurriculumTimeEstimateSettingProps) {
  const curriculumModules = ContentModuleUtils.useCurriculumModuleIds()
  const hasModules = curriculumModules.length > 0
  return (
    <>
      <DiscoFormControl
        marginBottom={1}
        marginTop={1}
        title={"Time Estimate"}
        titleTooltip={
          hasModules
            ? {
                label:
                  "AI will generate estimated completion times for all content in this curriculum. Review and adjust as needed to ensure accuracy.",
                placement: "right",
              }
            : undefined
        }
        variant={"one-column"}
        titleAction={
          <DiscoTooltip
            content={"Add modules to your curriculum to enable time estimates."}
            disabled={hasModules}
            placement={"left"}
          >
            <span>
              <DiscoSwitch
                testid={"ContentCurriculumTimeEstimateSetting.toggle"}
                name={"toggle-curriculum-time-estimate"}
                hideForm
                checked={form.state.enableCurriculumContentTimeEstimates ?? false}
                onChange={handleToggle}
                disabled={form.isSubmitting || !hasModules}
              />
            </span>
          </DiscoTooltip>
        }
      >
        <div>
          <DiscoText variant={"body-sm"} color={"groovy.neutral.700"} display={"inline"}>
            {"Show time to complete for all content in this curriculum."}
          </DiscoText>
        </div>
      </DiscoFormControl>

      {form.initialState.enableCurriculumContentTimeEstimates !==
        form.state.enableCurriculumContentTimeEstimates && (
        <DiscoAlert
          severity={"warning"}
          message={
            <DiscoText
              variant={"body-sm"}
              testid={"ContentCurriculumTimeEstimateSetting.warning"}
            >
              {form.state.enableCurriculumContentTimeEstimates
                ? "Turning this on will enable time estimates for all content in this curriculum. You can always adjust them later."
                : "Turning this off will remove time estimates for all content in this curriculum."}
            </DiscoText>
          }
          marginTop={1}
          marginBottom={0}
        />
      )}
    </>
  )

  function handleToggle(checked: boolean) {
    form.state.enableCurriculumContentTimeEstimates = checked
  }
}
export default observer(ContentCurriculumTimeEstimateSetting)
